import { render, staticRenderFns } from "./EstadoCuentas.vue?vue&type=template&id=6e4d0b82&scoped=true&"
import script from "./EstadoCuentas.vue?vue&type=script&lang=js&"
export * from "./EstadoCuentas.vue?vue&type=script&lang=js&"
import style0 from "./EstadoCuentas.vue?vue&type=style&index=0&id=6e4d0b82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4d0b82",
  null
  
)

export default component.exports